import { BeCheckBox, BeRow } from "@beos-css/react/index.ts";

export function CheckBoxDemo() {
	return (
		<section id="demo-checkbox">
			<h2>CheckBox (BCheckBox)</h2>
			<p>Recessed white well + a blue X (R5 draws an X, not a checkmark). Tab to it for the focus underline.</p>
			<BeRow wrap gap="row">
				<BeCheckBox defaultChecked>Show grid</BeCheckBox>
				<BeCheckBox>Snap to grid</BeCheckBox>
				<BeCheckBox defaultChecked disabled>
					Locked
				</BeCheckBox>
			</BeRow>
		</section>
	);
}
